export default __webpack_public_path__ + "static/media/sam_w320.52de179d.jpeg";